module.exports = __webpack_public_path__ + "img/logboek-leaf.9700fe0b.png";